import HotelListCardThumb from './HotelListCardThumb';

export default HotelListCardThumb;
